module.exports = __webpack_public_path__ + "img/Ma.Maritime.Revetments.Rockrevetment-optimised.Rock.f999a324.png";